export interface Document {
    user_id: string;
    id: string;
    type: DocumentType;
    specialty_type?: DocumentSpecialtyType;
    appointment_id?: string;

    name: string;
    mime_type: string;
    content_length?: number;
    path: string;
    status: DocumentStatus;

    // consent?

    // share/upload/sync
    sharing?: DocumentShare[];

    meta: {
        created_at: string;
        updated_at: string;
    };
}

export enum DocumentType {
    PRESCRIPTION = 'PRESCRIPTION',
    TRANSFER_SLIP = 'TRANSFER_SLIP',
    ANAMNESIS = 'ANAMNESIS',
    DOCTOR_LETTER = 'DOCTOR_LETTER',
    IMAGING = 'IMAGING',
    FINDINGS = 'FINDINGS',
    LAB_RESULTS = 'LAB_RESULTS',
    MEDICATION_PLAN = 'MEDICATION_PLAN',
    PROFILE_PICTURE = 'PROFILE_PICTURE',
    OTHER = 'OTHER',
}

export enum DocumentSpecialtyType {
    ENT = 'ENT',
    GENERAL_MEDICINE = 'GENERAL_MEDICINE',
    CARDIOLOGY = 'CARDIOLOGY',
    DERMATOLOGY = 'DERMATOLOGY',
    GYNECOLOGY = 'GYNECOLOGY',
    PLASTIC_SURGERY = 'PLASTIC_SURGERY',
    PHYSIOTHERAPY = 'PHYSIOTHERAPY',
    ORTHOPEDICS = 'ORTHOPEDICS',
    OTHER = 'OTHER',
    UNKNOWN = 'UNKNOWN',
}

export enum DocumentStatus {
    REQUESTED = 'REQUESTED',
    CREATED = 'CREATED',
    CANCELLED = 'CANCELLED',
    ARCHIVED = 'ARCHIVED',
    DELETED = 'DELETED',
}

export enum DocumentOrigin {
    CAF = 'CAF',
}

export interface DocumentShare {
    // system: string; // DC
    // system_id: string; // DC Instance Id

    is_shared: boolean;

    shared_date?: string; // ISO
    shared_target?: ShareTarget;
}

export interface ShareTarget {
    id: string;
    ext_id?: string;
    type: ShareTargetType;
}

export enum ShareTargetType {
    PROFESSIONAL = 'professional',
}

export interface DocumentResponseDto {
    document: Document;
    download_url?: string;
}
